import { flip as baseFlip } from '@floating-ui/dom';
import { getBoundary } from '../utils/index';
export function flip(options) {
  const {
    hasScrollableElement,
    flipBoundary,
    container
  } = options;
  return baseFlip({ ...(hasScrollableElement && {
      boundary: 'clippingAncestors'
    }),
    ...(flipBoundary && {
      altBoundary: true,
      boundary: getBoundary(container, flipBoundary)
    }),
    fallbackStrategy: 'bestFit'
  });
}
//# sourceMappingURL=flip.js.map